// recon-equity-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'rce.cat.shareCapital': 'Share capital',
  'rce.cat.cooperativeCapital': 'Jointly owned cooperative capital',
  'rce.cat.sharePremium': 'Share premium',
  'rce.cat.otherPaidIn': 'Other paid-in equity',
  'rce.cat.funds': 'Funds',
  'rce.cat.otherEarned': 'Other earned equity',
  'rce.cat.dividendProvision': 'Dividend provision charged to equity',
  'rce.cat.privateAccount': 'Private account, withdrawals and deposits',
  'rce.cat.uncoveredLoss': 'Uncovered loss / negative equity',
  'rce.cat.otherEquity': 'Other equity',
  'rce.type.dividendProvision': 'Dividend provision',
  'rce.type.profitAllocation': 'Allocation of profit',
  'rce.type.yearEndEntry': 'Year-end entry against equity',
  'rce.type.distribution': 'Distribution to owner',
  'rce.type.ownerCurrentAccount': 'Transaction against owner current account',
  'rce.type.receipt': 'Receipt posted against equity',
  'rce.type.payment': 'Payment posted against equity',
  'rce.flag.noDecisionBasis': 'Decision basis missing',
  'rce.flag.dispositionUnverified': 'Approved allocation cannot be verified',
  'rce.flag.calcDifference': 'Calculation difference',
  'rce.item.counterAccount': 'Counter account {codes}',
  'rce.item.statementDiff': '{label} — calculated closing differs from booked',
  'rce.item.accounts': 'Accounts: {codes}',
  'rce.item.driftTitle': '{code} {name} — the movement in the ledger does not explain the change in balance',
  'rce.item.driftDetail': 'The trial balance and the vouchers disagree about the movement on the account.',
  'rce.item.negativeTitle': 'Calculated equity is negative',
  'rce.item.negativeDetail': 'Negative equity must be assessed by the board and documented.',
  'rce.item.noShareCapitalTitle': 'No booked share capital on the equity accounts',
  'rce.item.noShareCapitalDetail': 'A limited company must have booked share capital.',
  'rce.item.noRegisterTitle': 'The share register has not been recorded in Plumme',
  'rce.item.noRegisterDetail': 'Without a share register, neither ownership nor distributions can be checked against the owners.',
  'rce.decision.recorded': 'General meeting recorded in Plumme',
  'rce.decision.uploaded': 'Uploaded minutes',
  'rce.disp.dividend': 'Ordinary dividend',
  'rce.disp.transfer': 'Transferred to other equity',
  'rce.disp.total': 'Total allocated',
  'rce.src.ledger': 'General ledger and trial balance',
  'rce.src.protocol': 'General meeting resolution',
  'rce.src.register': 'Share register',
  'rce.src.annual': 'Approved annual accounts for the previous year',
  'rce.src.registry': 'Registered share capital and capital changes (Register of Business Enterprises)',
  'rce.src.forecast': 'Budget and liquidity forecast',
  'rce.src.ledgerDetail': 'The equity accounts with opening balance and the movements year to date.',
  'rce.src.protocolMissing': 'Neither a recorded general meeting nor uploaded minutes for the year.',
  'rce.src.registerDetail': '{count} shareholders with a total of {shares} shares',
  'rce.src.registerMissing': 'No shareholders are recorded in Plumme.',
  'rce.src.articlesMissing': 'The articles of association have not been uploaded to the area.',
  'rce.src.annualMissing': 'The previous year\'s result could not be read.',
  'rce.src.annualDetail': 'Annual result {year}: {result} kr',
  'rce.src.registryDetail': 'Plumme does not fetch registered share capital or capital changes. Check manually against the register.',
  'rce.src.forecastDetail': 'A budget exists for the year. The app does not fetch a separate liquidity forecast.',
  'rce.src.forecastMissing': 'Neither a budget nor a liquidity forecast is available for the year.',
  'rce.check.rollforward': 'Opening equity plus movements equals closing equity',
  'rce.check.vouchers': 'The movements are covered by vouchers',
  'rce.check.decision': 'Distributions have a documented decision basis',
  'rce.check.allocation': 'Booked allocation adds up to the previous year\'s result',
  'rce.check.direct': 'Direct postings to equity are identified',
  'rce.check.owners': 'Transactions with owners are identified',
  'rce.check.capital': 'The capital requirement of the company form is booked',
  'rce.check.weak': 'Signs of weak or negative equity',
});
